import { jsx as _jsx } from "react/jsx-runtime";
import { Stack as ChakraStack, forwardRef, } from '@chakra-ui/react';
/**
 * Stacks help you easily create flexible and automatically distributed layouts
 * You can stack elements in the horizontal or vertical direction, and apply a space or/and divider between each element.
 * It uses display: flex internally and renders a div.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/stack
 */
export const Stack = forwardRef(({ children, ...props }, ref) => {
    return (_jsx(ChakraStack, { ref: ref, ...props, children: children }));
});
//# sourceMappingURL=stack.js.map